import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["backgroundColor", "fluid", "includeGlobalStyles"];
import React from 'react';
import PropTypes from 'prop-types';
import styled, { createGlobalStyle } from 'styled-components';
import { PageContext } from '../../js/PageContext';
import { PageMixin } from '../../mixins/components/PageMixin';
import { PageGlobalStyleMixin } from '../../mixins/components/PageGlobalStyleMixin';
export var PageGlobalStyle = /*#__PURE__*/createGlobalStyle(["", ""], PageGlobalStyleMixin);
export var StyledPage = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPage",
  componentId: "c11n-8-64-0__sc-5wrhgs-0"
})(["", ""], PageMixin);
/**
 * The page template defines the highest level of structure for the page. It defines things such as
 * page widths, margins, and padding, as well as how content chunks such as header, page title, and
 * footer are spaced relative to each other.
 *
 * @since 8.15.0
 */

var Page = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var backgroundColor = _ref.backgroundColor,
      fluid = _ref.fluid,
      includeGlobalStyles = _ref.includeGlobalStyles,
      rest = _objectWithoutProperties(_ref, _excluded);

  var context = {
    fluid: fluid
  };
  return /*#__PURE__*/React.createElement(PageContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(StyledPage, _extends({
    ref: ref,
    backgroundColor: backgroundColor
  }, rest)), includeGlobalStyles && /*#__PURE__*/React.createElement(PageGlobalStyle, null));
});
Page.displayName = 'Page';
Page.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A [color token](#/%40zillow%2Fconstellation/Tokens?id=section-colors) or `null`
   * to remove the default background color.
   */
  backgroundColor: PropTypes.string,

  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: PropTypes.bool,

  /**
   * By default, we include global style to remove the default margins from the `<body>` element.
   * You can disable adding of this global style by setting this to `false`.
   */
  includeGlobalStyles: PropTypes.bool
} : {};
Page.defaultProps = {
  includeGlobalStyles: true
};
export default Page;